/**
 * Configuración centralizada para Google Analytics
 * 
 * Este archivo contiene la configuración necesaria para Google Analytics,
 * lo que facilita actualizar el ID de seguimiento y otras configuraciones desde un solo lugar.
 */

// El ID de tu Google Analytics - IMPORTANTE: Ya configurado con tu ID real
export const GA_TRACKING_ID = 'G-38E6GGKY38';

// Configuración general para Google Analytics
export const GA_CONFIG = {
  // Campos de usuario que pueden ser enviados en los eventos
  USER_FIELDS: {
    user_id: 'user_id',        // ID de usuario
    email: 'email',            // Email 
    first_name: 'first_name',  // Primer nombre
    last_name: 'last_name',    // Apellido
  },
  
  // Parámetros comunes para eventos
  COMMON_PARAMS: {
    currency: 'MXN',    // Moneda predeterminada
    language: 'es_MX',  // Idioma predeterminado
    send_to: GA_TRACKING_ID
  }
}; 